import { defineMessages } from 'react-intl';

export const EcoLabelCardMessages = defineMessages({
  DialogHeadline: {
    defaultMessage: 'Produktstandard',
    id: 'ecoLabelList.dialog.headline',
  },
});
